import { render, staticRenderFns } from "./PlaceGallery.vue?vue&type=template&id=7a50a314"
import script from "./PlaceGallery.vue?vue&type=script&lang=ts"
export * from "./PlaceGallery.vue?vue&type=script&lang=ts"
import style0 from "./PlaceGallery.vue?vue&type=style&index=0&id=7a50a314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports